import React from 'react';
import BrandToggleBoolean from './BrandToggleBoolean';

export default function MascotEnabled({ children }) {
  return (
    <BrandToggleBoolean configKey="common.mascotEnabled">
      <React.Fragment>{children}</React.Fragment>
      <React.Fragment>{null}</React.Fragment>
    </BrandToggleBoolean>
  );
}
